import { css } from "@emotion/react";
import Link from "next/link";
import { LuExternalLink } from "react-icons/lu";
import {
  HatenaIcon,
  HatenaShareButton,
  LineIcon,
  LineShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";

import ResponseContent from "~/components/item/[id]/response-content";
import { mediaQueryIsDesktop, mediaQueryIsMobile } from "~/lib/client/design";
import {
  DatabaseDetailContentQuery,
  DatabaseDetailTableContentQuery,
} from "~/lib/graphql/client";

const ItemModalContent = (props: {
  form: DatabaseDetailContentQuery["form"];
  response: DatabaseDetailTableContentQuery["form"]["responses"][number];
}) => {
  const url =
    "https://" + window.location.hostname + `/item/${props.response.id}`;
  return (
    <div css={rootStyle}>
      <ResponseContent
        questions={props.form.questions}
        response={props.response}
      />
      <Link
        href={`/item/${props.response.id}`}
        target={"_blank"}
        rel={"noopener noreferrer"}
        css={openInNewTabLinkStyle}
      >
        別のタブで開く
        <LuExternalLink />
      </Link>

      <hr css={hrStyle} />
      <section css={shareButtonContainerStyle}>
        <h2>共有する</h2>
        <TwitterShareButton url={url} title={`${props.form.title}への回答`}>
          <TwitterIcon size={32} round />
        </TwitterShareButton>
        <LineShareButton url={url}>
          <LineIcon size={32} round />
        </LineShareButton>
        <HatenaShareButton url={url} title={`${props.form.title}への回答`}>
          <HatenaIcon size={32} round />
        </HatenaShareButton>
      </section>
    </div>
  );
};

const rootStyle = css`
  ${mediaQueryIsMobile(css`
    margin: 0.25rem;
  `)};

  ${mediaQueryIsDesktop(css`
    padding: 2rem;
  `)};
  padding-bottom: 2rem;
`;

const hrStyle = css`
  margin: 1rem 0.5rem;
`;

const shareButtonContainerStyle = css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;

  h2 {
    display: none;
  }
`;

const openInNewTabLinkStyle = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 2rem;
  font-size: 0.8rem;
`;

export default ItemModalContent;
